import React from "react";
import ReactDOM from "react-dom/client";
// The shared base first: it declares the cascade layers' order.
import "@jkast90/kast-common/base.css";
import "./index.css";
import "@jkast90/kast-common/theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
import App from "./App";
// index.html already set the theme; the store starts following the OS for "system".
import "@common/theme";
import { completeSignIn } from "./auth/session";

// Back from login.kast-dev.net: signed in, and on the right page, from the first frame.
completeSignIn();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
